// Nolena Global — site configuration & content
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_nolena-pet-hub/artifacts/lzv5l688_image.png";

// Bayilik başvurusu T-Soft bayi başvuru sayfasına yönlendirilir.
export const DEALERSHIP_URL =
  "https://bayi.nolenaglobal.com/bayi-basvuru-sayfasi";

export const NAV_LINKS = [
  { label: "Ana Sayfa", target: "#top" },
  { label: "Hakkımızda", target: "#hakkimizda" },
  { label: "Markalarımız", target: "#markalar" },
  { label: "Ürünler", target: "#urunler" },
  { label: "Bayilik", target: "#bayilik" },
  { label: "İletişim", target: "#iletisim" },
];

export const TRUST_ITEMS = [
  { icon: "ShieldCheck", title: "Kaliteli üretim" },
  { icon: "Handshake", title: "Güvenilir iş ortaklığı" },
  { icon: "MapPin", title: "Türkiye'ye yayılmış bayi ağı" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Kalite",
    text:
      "Her ürünü, evimizin bir üyesi için hazırlar gibi titizlikle üretiyoruz. Hammadde seçiminden son kontrole kadar her aşamada yüksek standartları koruyoruz.",
  },
  {
    no: "02",
    title: "Güven",
    text:
      "Bayilerimiz ve tüketicilerimiz için istikrarlı, şeffaf ve sürdürülebilir bir üretim anlayışı benimsiyoruz. Verdiğimiz sözün arkasında duruyoruz.",
  },
  {
    no: "03",
    title: "İş Ortaklığı",
    text:
      "Büyümeyi birlikte kurguluyoruz. Güçlü markalarımız ve geniş portföyümüzle bayilerimize uzun vadeli, kazançlı bir iş ortaklığı sunuyoruz.",
  },
];

export const BRANDS = [
  {
    name: "Merry Cat",
    tag: "Cat Food",
    text: "Kedilerin damak zevkine ve günlük ihtiyaçlarına odaklanan ürünler.",
    image: "/images/brands/merrycat.jpg",
    alt: "Merry Cat logosu",
  },
  {
    name: "Merry Dog",
    tag: "Dog Food",
    text: "Köpeklerin enerjisine ve dengeli beslenmesine eşlik eden ürünler.",
    image: "/images/brands/merrydog.jpg",
    alt: "Merry Dog logosu",
  },
  {
    name: "Pharmadyn",
    tag: "Professional Pet Care",
    text: "Evcil dostların günlük bakım ihtiyaçları için profesyonel çözümler.",
    image: "/images/brands/pharmadyn.jpg",
    alt: "Pharmadyn Professional Pet Care logosu",
  },
  {
    name: "OptiNutra",
    tag: "Optimal Nutrition",
    text: "Dengeli içerik yaklaşımıyla geliştirilen beslenme çözümleri.",
    image: "/images/brands/optinutra.jpg",
    alt: "OptiNutra Optimal Nutrition logosu",
  },
];

const createSampleProducts = ({ brandId, names, image, category }) => names.map((name, index) => {
  const productName = typeof name === "string" ? name : name.name;
  const subcategory = typeof name === "string" ? category : name.subcategory;
  const no = String(index + 1).padStart(2, "0");
  const id = `${brandId}-ornek-${no}`;

  return {
    id,
    name: productName,
    subcategory,
    description: `${productName}, ${subcategory} için hazırlanmış örnek ürün kaydıdır. Ürün bilgileri, görseller ve ticari detaylar bayi kullanımı için örneklenmiştir.`,
    barcode: `86900000${brandId.length}${no}0`,
    supplierCode: `${brandId.toUpperCase().slice(0, 3)}-SMP-${no}`,
    image,
    isSample: true,
    files: [{ path: image, filename: `${id}-ornek-gorsel${image.endsWith(".png") ? ".png" : ".jpg"}` }],
  };
});

export const PRODUCT_DOWNLOADS = [
  {
    id: "merry-cat",
    name: "Merry Cat",
    products: [
      {
        id: "merry-natural-kedi-kumu-5l",
        name: "Merry Natural Kedi Kumu 5 L",
        description: "Merry Natural Kedi Kumu, doğal ve sade kullanım tercih eden kedi sahipleri için geliştirilmiştir. Güçlü topaklanan bentonit yapısı sayesinde sıvıyı hızlı emer ve kolay temizlenir. Parfüm içermeyen doğal formülü, kötü kokuların kontrol altına alınmasına yardımcı olurken düşük tozlanma özelliğiyle daha temiz bir kullanım deneyimi sunar. Günlük kullanım için pratik, hijyenik ve konforlu bir çözümdür.",
        barcode: "8685210580027",
        supplierCode: "MRY-002",
        subcategory: "Kedi Kumu",
        image: "/images/products/merry-natural-cat-litter-5l/urun-gorseli.png",
        isSample: false,
        files: [
          { path: "/images/products/merry-natural-cat-litter-5l/urun-gorseli.png", filename: "merry-natural-kedi-kumu-5l-urun-gorseli.png" },
          { path: "/images/products/merry-natural-cat-litter-5l/temiz-patiler.png", filename: "merry-natural-kedi-kumu-5l-temiz-patiler.png" },
          { path: "/images/products/merry-natural-cat-litter-5l/kullanim-talimati.png", filename: "merry-natural-kedi-kumu-5l-kullanim-talimati.png" },
        ],
      },
      ...createSampleProducts({
        brandId: "merry-cat",
        category: "kedi kumu kategorisi",
        image: "/images/brands/merrycat.jpg",
        names: [
          { name: "Merry Lavanta Kedi Kumu 5 L", subcategory: "Kedi Kumu" },
          { name: "Merry Aktif Karbon Kedi Kumu 10 L", subcategory: "Kedi Kumu" },
          { name: "Merry Tavuklu Kedi Maması 1.5 Kg", subcategory: "Kedi Maması" },
          { name: "Merry Somonlu Kedi Maması 1.5 Kg", subcategory: "Kedi Maması" },
          { name: "Merry Yavru Kedi Maması 1.5 Kg", subcategory: "Kedi Maması" },
          { name: "Merry Tavuklu Kedi Pouch 85 g", subcategory: "Kedi Pouch" },
          { name: "Merry Ton Balıklı Kedi Pouch 85 g", subcategory: "Kedi Pouch" },
          { name: "Merry Tavuklu Kedi Et Ezmesi 80 g", subcategory: "Kedi Et Ezmesi" },
          { name: "Merry Karışık Kedi Et Ezmesi 80 g", subcategory: "Kedi Et Ezmesi" },
        ],
      }),
    ],
  },
  {
    id: "merry-dog",
    name: "Merry Dog",
    products: createSampleProducts({
      brandId: "merry-dog",
      category: "köpek beslenmesi kategorisi",
      image: "/images/brands/merrydog.jpg",
      names: ["Merry Dog Yetişkin Köpek Maması 3 Kg", "Merry Dog Kuzu Etli Köpek Maması 3 Kg", "Merry Dog Tavuklu Köpek Maması 3 Kg", "Merry Dog Yavru Köpek Maması 2 Kg", "Merry Dog Hassas Sindirim 3 Kg", "Merry Dog Aktif Yaşam 3 Kg", "Merry Dog Küçük Irk Köpek Maması 2 Kg", "Merry Dog Büyük Irk Köpek Maması 12 Kg", "Merry Dog Somonlu Köpek Maması 3 Kg", "Merry Dog Kuzu Pirinçli Köpek Maması 12 Kg"],
    }),
  },
  {
    id: "pharmadyn",
    name: "Pharmadyn",
    products: createSampleProducts({
      brandId: "pharmadyn",
      category: "profesyonel pet bakım kategorisi",
      image: "/images/brands/pharmadyn.jpg",
      names: ["Pharmadyn Kedi Şampuanı 250 ml", "Pharmadyn Köpek Şampuanı 250 ml", "Pharmadyn Kulak Temizleme Solüsyonu 100 ml", "Pharmadyn Göz Çevresi Temizleme Mendili", "Pharmadyn Ağız Bakım Spreyi 100 ml", "Pharmadyn Pati Bakım Kremi 50 ml", "Pharmadyn Tüy Açıcı Sprey 250 ml", "Pharmadyn Koku Giderici Sprey 500 ml", "Pharmadyn Hassas Deri Şampuanı 250 ml", "Pharmadyn Tüy Bakım Serumu 100 ml"],
    }),
  },
  {
    id: "optinutra",
    name: "OptiNutra",
    products: createSampleProducts({
      brandId: "optinutra",
      category: "tamamlayıcı beslenme kategorisi",
      image: "/images/brands/optinutra.jpg",
      names: ["OptiNutra Multivitamin Kedi 100 g", "OptiNutra Multivitamin Köpek 100 g", "OptiNutra Eklem Desteği 120 g", "OptiNutra Tüy ve Deri Desteği 100 g", "OptiNutra Bağışıklık Desteği 100 g", "OptiNutra Sindirim Desteği 100 g", "OptiNutra Omega 3 Desteği 100 ml", "OptiNutra Probiyotik Desteği 60 g", "OptiNutra Enerji Desteği 100 g", "OptiNutra Yaşlı Dost Desteği 100 g"],
    }),
  },
];

export const CATEGORIES = [
  {
    key: "kedi",
    title: "Kedi Ürünleri",
    desc: "Mama, kum ve bakım çözümleri",
    image:
      "https://images.unsplash.com/photo-1663000372328-01a250654120?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwY2F0JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg0MDQ5NzMwfDA&ixlib=rb-4.1.0&q=85",
    alt: "Kameraya bakan premium bir kedi portresi",
  },
  {
    key: "kopek",
    title: "Köpek Ürünleri",
    desc: "Mama, ödül ve oyuncaklar",
    image:
      "https://images.unsplash.com/photo-1612940960267-4549a58fb257?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwZG9nJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg0MDQ5NzMwfDA&ixlib=rb-4.1.0&q=85",
    alt: "Kahverengi ve beyaz bir corgi yavrusu portresi",
  },
  {
    key: "bakim",
    title: "Bakım Ürünleri",
    desc: "Şampuan, tarak ve hijyen",
    image:
      "https://images.unsplash.com/photo-1597595735781-6a57fb8e3e3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxwZXQlMjBjYXJlJTIwZ3Jvb21pbmd8ZW58MHx8fHwxNzg0MDQ5NzMwfDA&ixlib=rb-4.1.0&q=85",
    alt: "Yıkanan bir Fransız bulldog",
  },
  {
    key: "aksesuar",
    title: "Aksesuarlar",
    desc: "Tasma, yatak ve taşıma",
    image:
      "https://images.unsplash.com/photo-1596822316110-288c7b8f24f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxwZXQlMjBhY2Nlc3NvcmllcyUyMGNvbGxhcnxlbnwwfHx8fDE3ODQwNDk3MzB8MA&ixlib=rb-4.1.0&q=85",
    alt: "Mavi tasmalı siyah beyaz bir kedi",
  },
];

export const ADVANTAGES = [
  {
    icon: "Megaphone",
    title: "Güçlü marka desteği",
    text: "Bilinirliği yüksek markalarımızla satış gücünüzü artırın.",
  },
  {
    icon: "PackageSearch",
    title: "Geniş ürün portföyü",
    text: "Kedi, köpek, bakım ve aksesuar kategorilerinde zengin seçki.",
  },
  {
    icon: "TrendingUp",
    title: "Satış ve pazarlama desteği",
    text: "Kampanya, görsel ve saha desteğiyle her zaman yanınızdayız.",
  },
  {
    icon: "Truck",
    title: "Hızlı tedarik",
    text: "Güçlü lojistik ağımızla siparişleriniz zamanında elinizde.",
  },
];

export const CONTACT = {
  phone: "+90 212 909 52 42",
  phoneHref: "tel:+902129095242",
  email: "info@nolenaglobal.com",
  address: "The Office, Ziya Gökalp, Süleyman Demirel Blv. Mall of Istanbul No:7 D:E, 34490 Başakşehir/İstanbul",
  socials: [
    { icon: "Instagram", label: "Instagram", href: "#" },
    { icon: "Facebook", label: "Facebook", href: "#" },
    { icon: "Linkedin", label: "LinkedIn", href: "#" },
    { icon: "Twitter", label: "X", href: "#" },
  ],
};

export const HERO_IMAGE = {
  url:
    "https://images.unsplash.com/photo-1450778869180-41d0601e046e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwY2F0JTIwYW5kJTIwZG9nJTIwdG9nZXRoZXJ8ZW58MHx8fHwxNzg0MDQ5NzMwfDA&ixlib=rb-4.1.0&q=85",
  alt: "Çimenlerin üzerinde birbirine sarılan beyaz bir köpek ve gri bir kedi",
};
